import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';

const OrderButton = ({ label, onClick, variant, disabled, isLoading }) => {
  return (
    <Spinner label={label} size="small" spinning={isLoading} inline>
      <button
        type="button"
        className={`frg-button color-${variant}`}
        disabled={disabled}
        onClick={onClick}
      >
        {label}
      </button>
    </Spinner>
  );
};

OrderButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};

OrderButton.defaultProps = {
  isLoading: false,
  disabled: false
};

export default OrderButton;
